"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const hopper_control_line_types_1 = require("./hopper-control-line.types");
const app_types_1 = require("pages/app.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataBrand: [],
    dataDumping: [],
    dataDropdown: [],
    mutationMode: false,
    dataItem: {
        id: '',
        inEdit: false,
        brand1_name: '',
        brand2_name: '',
        brand3_name: '',
        modified_by: '',
        dumping_type: '',
        isDisabled: false,
        checkpoint_id: '',
        checkpoint_name: '',
        brand2_disabled: false,
        brand3_disabled: false,
        modified_date: new Date()
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'checkpoint_name', dir: 'asc' }]
    }
};
const hopperConfigReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [hopper_control_line_types_1.hopperConfigTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [hopper_control_line_types_1.hopperConfigTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [hopper_control_line_types_1.hopperConfigTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        const newDatabrand = state.dataBrand.filter(x => {
            return x.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand1_name) &&
                x.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand2_name) &&
                x.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand3_name);
        });
        const defaultBrand = [{
                id: '',
                code: '',
                name: '-',
                is_active: true,
                created_by: '',
                modified_by: '',
                created_date: new Date(),
                modified_date: new Date()
            }];
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataDropdown: defaultBrand.concat(newDatabrand), dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [hopper_control_line_types_1.hopperConfigTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [hopper_control_line_types_1.hopperConfigTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, isError,
            errorCode,
            errorMessage, isSuccess: false });
    },
    [hopper_control_line_types_1.hopperConfigTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [hopper_control_line_types_1.hopperConfigTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [hopper_control_line_types_1.hopperConfigTypes.ON_ENTER_EDIT_CLICK]: (state, action) => {
        const { dataGrid, dataItem, dataBrand, mutationMode } = action.payload;
        const brand_default = {
            id: '',
            code: '',
            name: '',
            is_active: true,
            created_by: '',
            modified_by: '',
            created_date: new Date(),
            modified_date: new Date()
        };
        const brand1_data = dataBrand.find(item => item.name === dataItem.brand1_name) || brand_default;
        const brand2_data = dataBrand.find(item => item.name === dataItem.brand2_name) || brand_default;
        const brand3_data = dataBrand.find(item => item.name === dataItem.brand3_name) || brand_default;
        const dumping_data = state.dataDumping.find(item => item.value === dataItem.dumping_type) || {
            id: '',
            type: '',
            value: '',
            created_by: '',
            modified_by: '',
            is_active: false,
            created_date: new Date(),
            modified_date: new Date()
        };
        const newDataDropdown = state.dataBrand.filter(item => {
            return item.name !== dataItem.brand1_name &&
                item.name !== dataItem.brand2_name &&
                item.name !== dataItem.brand3_name;
        });
        const newDataItem = Object.assign(Object.assign({}, dataItem), { brand1_data,
            brand2_data,
            brand3_data,
            dumping_data, brand1_name: brand1_data.name, brand2_name: brand2_data.name, brand3_name: brand3_data.name, dumping_type: dumping_data.value });
        return Object.assign(Object.assign({}, state), { dataGrid,
            mutationMode, dataItem: mutationMode ? newDataItem : initialState.dataItem, dataDropdown: mutationMode
                ? [Object.assign(Object.assign({}, brand_default), { id: '', name: '-' })].concat(newDataDropdown)
                : state.dataDropdown });
    },
    [hopper_control_line_types_1.hopperConfigTypes.SET_DATA_BRAND]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataBrand: action.payload.dataBrand, dataDropdown: action.payload.dataBrand });
    },
    [hopper_control_line_types_1.hopperConfigTypes.SET_DATA_ENUM_DUMPING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataDumping: action.payload.dataDumping });
    }
});
exports.default = hopperConfigReducer;
